import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-change-plans',
  imports: [CommonModule,FormsModule],
  templateUrl:'./change-plans.component.html',
  styleUrl: './change-plans.component.scss'
})
export class ChangePlansComponent {
  plans = [
    {
      id: 1,
      name: 'Business Essential',
      downloadSpeed: 75,
      uploadSpeed: 75,
      description: 'Business Essential plan for lightweight usage (POS/VoIP).',
      price: 99,
    },
    {
      id: 2,
      name: 'Residential 100/100 Unlimited',
      downloadSpeed: 100,
      uploadSpeed: 100,
      description:
        '$499 Installation Fee. 1 Hour Installation Included (adequate for a standard installation). No Router Included.',
      price: 99,
    },
    {
      id: 3,
      name: 'Business Essential',
      downloadSpeed: 500,
      uploadSpeed: 500,
      description:
        '$499 Installation Fee. 1 Hour Installation Included (adequate for a standard installation). No Router Included.',
      price: 99,
    },
    {
      id: 4,
      name: 'Residential 100/100 Unlimited',
      downloadSpeed: 100,
      uploadSpeed: 100,
      description:
        '$499 Installation Fee. 1 Hour Installation Included (adequate for a standard installation). No Router Included.',
      price: 99,
    },
  ];

  selectedPlan: number | null = null;
}
